/**
 * 
 * Lead Header
 * 
 */


 import React, { useState, useEffect } from 'react'
 import PropTypes from 'prop-types'
 import MetaTags from 'react-meta-tags'
 import {
     Container,
     Row,
     Col,
     Button,
 } from "reactstrap"
 import { useDispatch, useSelector } from 'react-redux'
 import { resolveColumns } from '../../../../helpers/tools'
 
 //Import Breadcrumb
 import Breadcrumbs from "../../../../components/Common/Breadcrumb"
 
 //Import Create Form
 import CreateForm from '../../../../components/CreateForm'
 
 //Import Styles
 import "../../styles.scss"
 
 function LeadHeader(props) {
     const { name, columns = [], title, actions = {}, metaData, formTitle, onSubmitValues } = props
    //   console.log(metaData.companyOptions,"lead header metadata")
     const [formRecord, setFormRecord] = useState({})
     const fields = resolveColumns(columns, formRecord, metaData)
     const dispatch = useDispatch()
     const session = useSelector(state => state.session || {})
     const breadcrumbItemTitle = name === 'lead' ? 'Manage Lead' : name === 'mylead' ? 'My Lead' : name === 'unassignedlead' ? 'Unassigned Lead' : ''
    
     useEffect(() => {
        dispatch(actions.loadRecordsMetaData())
    }, [])

     return (
         <React.Fragment>
             <div>
                 <MetaTags>
                     <title>{title} | Zero Gravity CRM</title>
                 </MetaTags>
                 <Container fluid>
                     {/* Render Breadcrumb */}
                     <Breadcrumbs
                         title={'Leads'}
                         breadcrumbItem={breadcrumbItemTitle}
                     />
 
                     <Row style={{ display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-between', marginBottom: '12px' }}>
                         <Col style={{ flex: '1 2', display: 'flex', justifyContent: 'flex-end' }}>
                             {session && session.user && session.user.roleId != '626e5d8c5dc812eb1938c94f' ? <CreateForm
                                 {...props}
                                 title={`Add ${formTitle}`}
                                 formTitle={`Add ${formTitle}`}
                                 fields={fields.filter(_ => _.editRecord)}
                                 metaData={metaData}
                                 formatterStyle={{ width: '100%' }}
                                 onChange={(data) => setFormRecord(data)}
                                 onCancel={() => setFormRecord({})}
                                 onSubmit={(data, setSubmitting, redirect,metaData) => {
                                     console.log(metaData,"inside form")
                                     setFormRecord({})
                                     dispatch(actions.createRecord(onSubmitValues ? onSubmitValues(data) : data, setSubmitting, redirect))
                                     //submitFunction(data)
                                 }}>
                                 {(openModal) => (
                                     <Button
                                         id="add-lead-btn"
                                         onClick={openModal}
                                         color="primary">
                                         {`Add ${title}`}
                                     </Button>)}
                             </CreateForm> : null}
                         </Col>
                     </Row>
 
 
                 </Container>
             </div>
         </React.Fragment>
     )
 
 }
 
 LeadHeader.propTypes = {
     t: PropTypes.any,
     name: PropTypes.any,
     columns: PropTypes.func,
     title: PropTypes.string,
     actions: PropTypes.object,
     access: PropTypes.array,
     metaData: PropTypes.object,
     loading: PropTypes.any,
     formTitle: PropTypes.string,
     onSubmitValues: PropTypes.func
 }
 
 
 export default LeadHeader
